import React from 'react';
import { useTranslation } from 'react-i18next';

export const DisabledChartPlaceholder: React.FC = () => {
    const { t } = useTranslation('common');

    return (
        <div className="w-full h-full min-h-[140px] flex flex-col items-center justify-center p-4 text-center select-none bg-neutral-50/50 dark:bg-neutral-900/30 rounded-xl border border-dashed border-neutral-200 dark:border-neutral-800">
            <div className="w-8 h-8 rounded-lg bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center mb-2 text-neutral-400">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                </svg>
            </div>
            <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400">
                {t('charts.currentlyUnavailable', 'This chart is currently unavailable')}
            </p>
        </div>
    );
};
